<script>
import { Form, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { ar } from "yup-locales";
import { createStoreInstance } from "../state/state.js";

export default {
  name: "Calculator",
  components: {
    Form,
    ErrorMessage,
  },
  provide() {
    return {
      store: this.store
    }
  },
  props: ["restUrl", "lang", "productItem", "name"],
  beforeCreate() {
    this.store = createStoreInstance()
  },
  methods: {
    async onSubmit(data) {
      // TODO: recaptcha live - uncomment
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha('login');
      this.store.formError = false;
      // TODO: recaptcha live - uncomment
      this.store.onSubmit(data, undefined, token);
      // TODO: recaptcha live - comment
      // this.store.onSubmit(data, undefined, 'token');
    },
    onInvalidSubmit(error) {
      this.store.formError = true;
      console.log({ ...error });
    },
    evaluateVisibilityCondition(visibilityConditions, field) {
      // set loadAmount with restters rules
      if (field.id == this.name + "_loan_amount") {
        this.loanAmountVRs = field.value_resetters;
      }

      // should this element be visible?
      if (
        visibilityConditions === undefined ||
        visibilityConditions.length === 0
      ) {
        return true;
      } else {
        const fieldVisibilityCondition = visibilityConditions[0];

        // potential returned value of this function
        // x: returnedBooleanExpression
        // y: evaluatedCondition
        let returnedBooleanExpression =
          fieldVisibilityCondition.operator == "and" ? true : false;

        // based on operator it will perform && or || operation on a giving two boolean
        const opFun =
          fieldVisibilityCondition.operator == "and"
            ? (x, y) => x && y
            : (x, y) => x || y;

        fieldVisibilityCondition.field_value_pairs.map((field_value_pair) => {
          let evaluatedCondition = true;
          let selectedFieldValue = this.store.calcModel[field_value_pair.field];

          if (typeof this.store.calcModel[field_value_pair.field] === "object") {
            selectedFieldValue = this.store.calcModel[field_value_pair.field].value;
          }

          evaluatedCondition = selectedFieldValue == field_value_pair.value;
          returnedBooleanExpression = opFun(
            returnedBooleanExpression,
            evaluatedCondition
          );
        });

        // returns visibility boolean
        return returnedBooleanExpression;
      }
    },
    evaluateValueResetter(field) {

      this.store.emptyDropDownOptions();

      this.store.calcFields.map((resetter) => {
        const theResetters = resetter.value_resetters;
        const fieldID = resetter.id;
        const fieldType = resetter.type;

        // find currently rendered field
        theResetters.map((current) => {
          if (this.store.calcModel[current.field_value_pairs[0].field] ==
            current.field_value_pairs[0].value) {
            this.store.resetAField(current, field.id, fieldID, fieldType);
          }
        });
      });

      this.validate();
    },
    validate() {
      const schema = {};

      this.store.calcFields.map(v => {
        if (this.evaluateVisibilityCondition(v.visibility_conditions, v)) {
          if (v.type == "slider" || (v.type == "number" && v.allow_empty == 0)) {
            let minNum =0;
            let maxNum =0;
            if(this.store.resetterCache[v.id + "_min"]){
              minNum = this.store.resetterCache[v.id + "_min"];
              maxNum = this.store.resetterCache[v.id + "_max"];
            }else{
              // fallback to min max value from default field
              const fieldFromStore = this.store.calcFields.filter(calcField=> calcField.id == v.id)
              minNum = fieldFromStore[0]['min_value'] || null;
              maxNum = fieldFromStore[0]['max_value'] || null;
            }
            schema[v.id] = this.validateWithMinMax( v.title, minNum, maxNum );
          } else if (v.type == "number" && v.allow_empty == 1) {
            schema[v.id] = Yup.string().label(v.title)

          } else if (v.type == "select" || v.type == "slider-stepper" ) {
            schema[v.id] = Yup.string().ensure().required().label(v.title)
          } 
          if (v.id =="total_loan_amount"){
            const auto_car_price = this.store.calcModel['auto_car_price']
            if(auto_car_price){
              schema['auto_down_payment'] = Yup
                .number()
                .transform((value) => (isNaN(value) ? undefined : value))
                .required()
                .positive()
                .min(Number(auto_car_price)/2)
                .max(auto_car_price)
                .label(v.title)
            }
            schema[v.id] = Yup
                .number()
                .transform((value) => (isNaN(value) ? undefined : value))
                .required()
                .positive()
                .min(15000)
                .max(350000)
                .label(v.title)
          }
        }
      })
      this.store.validationSchema = Yup.object().shape(schema);
    },
    validateWithMinMax(fieldTitle, minNum, maxNum) {
      const toint= (o, v) => {
        const intV = parseInt(v.toString().replaceAll(/,/g, ''));
        if(isNaN(intV)){
          return undefined
        }
        return intV;
      };
      if (minNum && maxNum) {
        return Yup
          .number()
          .transform(toint)
          .required()
          .positive()
          .min(minNum)
          .max(maxNum)
          .label(fieldTitle);
      } else if (maxNum == null) {
        return Yup.number()
        .transform(toint)
        .required().positive().min(minNum).label(fieldTitle);
      } else if (minNum == null) {
        return Yup.number()
        .transform(toint)
        .required().positive().max(maxNum).label(fieldTitle);
      }
      return Yup.number().transform(toint).required().positive().label(fieldTitle);
    },
  },
  async mounted() {
    const currentLang = window.CurrentLanguage || this.lang || 'en';
    this.store.setLang(currentLang);

    if(currentLang == 'ar'){
      Yup.setLocale(ar)
    }

    //set props to be shared in the store
    if (this.productItem != null) {
      this.store.setProductItem(this.productItem);
    }
    this.store.setName(this.name);
    
    this.store.SetURL(this.restUrl)
    
    // TODO: recaptcha live - uncomment
    await this.$recaptchaLoaded();
    const token = await this.$recaptcha('login');

    const myHeaders = new Headers();
    // TODO: recaptcha live - uncomment
    myHeaders.append("Authorization", token);
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    // console.log("token >>>", token);
    // Get Apis
    fetch(this.store.getURL, {
      headers: myHeaders,
    })
      .then((res) => {
        return res.json();
      })
      .then((response) => {
        this.store.setCalcFields(response.data.fields);
        if(response.data.automaticCalculation){
          this.store.setAutomaticCalc([ ...response.data.automaticCalculation ]);
        }
        this.store.setCalcTitles(response.data);
        this.store.loading = false; // loading done
        response.data.fields.map(field=>{
          if (this.evaluateVisibilityCondition(field.visibility_conditions, field)) {
            this.evaluateValueResetter(field);
          }
        })
      })
      .catch((error) => {
        console.error("error", error);
        this.store.loading = false; // loading done catch
      });
  },
};
</script>

<template>
    <section class="ideal-loan-calculator mr-bottom" :class="{
      'ideal-loan-calculator--loading': store.loading,
      'ideal-loan-calculator--loaded': !store.loading,
    }" :id="'AgricoleMainCalc_' + name" ref="calculator">
      <div class="container">
        <div class="calc-holder">
          <div class="row">
            <!--------------------------- Calc left side ----------------------->
            <div class="col-md-6">
              <Form @submit="onSubmit" 
              :validation-schema="store.validationSchema" @invalid-submit="onInvalidSubmit">
                <div class="row">
                  <!-- load input -->
                  <template v-for="field in store.calcFields">
                    <template v-if="(field.id != null) &&
                      evaluateVisibilityCondition(
                        field.visibility_conditions,
                        field
                      )
                    ">

                      <div class="form-group col-md-12"  :class="[( field.type === 'note' ? 'removeNote' : '')]" :key="field.id">

                        <template v-if="field.type != 'checkbox'">
                          <div class="slider-labelbox">
                            
                            <FieldLabel :field="field" />
                            <FieldSliderInput v-if="field.type == 'slider'" type="number" :field="field" :name="field.id"
                            :value="field.min_value" 
                            :label="field.title" 
                            :placeholder="field.place_holder" />

                          </div>
                        </template>

                        <template v-if="field.type == 'checkbox'">
                          <div class="slider-labelcheckbox">

                            <FieldCheckbox v-if="field.type == 'checkbox'" :field="field" />
                            <FieldLabel :field="field" />
                        
                          </div>
                        </template>
                        
                        <template v-if="field.type === 'radio'">
                          <FieldRadio :field="field" :name="field.id" :label="field.title"
                            @onEvaluateValueResetter="evaluateValueResetter" />
                        </template>

                        <template v-if="field.type === 'slider-stepper'">
                          <FieldSliderStepper :field="field" :name="field.id" :label="field.title"/>
                        </template>

                        <template v-if="field.type === 'select'">
                          <FieldSelect :field="field" :name="field.id" :label="field.title"
                            @onEvaluateValueResetter="evaluateValueResetter" />
                        </template>

                        <template v-if="field.type === 'number'">
                          <FieldNumber :field="field" :name="field.id" :label="field.title"
                            :placeholder="field.place_holder" @onEvaluateValueResetter="evaluateValueResetter" />
                        </template>

                        <template v-if="field.type === 'note'">
                          <FieldNote :field="field" @onEvaluateValueResetter="evaluateValueResetter" />
                        </template>

                        <template v-if="
                          field.type === 'slider' &&
                          !store.resetterCache[field.id + '_hide']
                        ">
                          <FieldSlider :field="field" :name="field.id" :label="field.title"
                            :placeholder="field.place_holder" @onEvaluateValueResetter="evaluateValueResetter" />
                        </template>

                        <ErrorMessage class="invalid-feedback" :name="field.id.toString()" />
                      </div>
                    </template>
                  </template>
                  <div class="form-group col-md-12">
                    <CalculateButton :scrollto="$refs.calculator" />
                  </div>
                </div>
              </Form>
            </div>

            <!--------------------------- Calc right side ----------------------->
            <div class="col-md-6 result-column">
              <Result />
              <br />
              <FormValidationMsg />
            </div>
          </div>
        </div>
      </div>
    </section>
</template>
